import { gql } from 'urql';

export const ToggleSafeCreditBuilder = gql`
  mutation ToggleSafeCreditBuilder($input: ToggleSafeCreditBuilderInput!) {
    toggleSafeCreditBuilder(input: $input) {
      ... on ToggleSafeCreditBuilderSuccess {
        message
        enabled
      }
      ... on ToggleSafeCreditBuilderError {
        message
      }
    }
  }
`;

export default ToggleSafeCreditBuilder;
